import { Popover } from '@mui/material';
import React from 'react'; // component props interface

interface PopoverLayoutProps {
    children: React.ReactNode;
    popoverClose: () => void;
    popoverOpen: boolean;
    anchorRef: React.RefObject<HTMLButtonElement | HTMLElement | null>;
    hiddenViewButton?: boolean;
    title?: string;
}

const PopoverLayout: React.FC<PopoverLayoutProps> = (props) => {
    const { children, popoverClose, popoverOpen, anchorRef } = props;
    return (
        <Popover
            open={popoverOpen}
            onClose={popoverClose}
            anchorEl={anchorRef.current}
            anchorOrigin={{
                horizontal: `center`,
                vertical: `bottom`,
            }}
            PaperProps={{
                sx: {
                    padding: `0.5rem`,
                },
            }}
        >
            {children}
        </Popover>
    );
};

export default PopoverLayout;
